import { DisabledPrompt, Link } from "bcms-react";

/**
 * @function BID126ProfilePageContent
 * @return {React.Component}
 * @exported true
 * @description A custom component for the BID 126's profile page content.
 */
export default function BID126ProfilePageContent(props) {
  return (
    <div className="flex-container flex-vertical">
      <div className="flex-height link-item">
        <Link to="/menuPage/changeProfile">Change Profile</Link>
      </div>
      <div className="flex-height link-item">
        <Link to="/authorizedDevicesWorkflow">Face/Touch ID</Link>
      </div>
      <div className="flex-height link-item">
        <Link to="/stoppedNumbers">Stopped Numbers</Link>
      </div>
      <div className="flex-height link-item">
        <Link to="/textBanking">Text Banking</Link>
      </div>
      <div className="flex-height link-item">
        <Link to="/settingsFastBalancesWorkflow">Fast Balances</Link>
      </div>
      <div className="flex-height link-item">
        <Link to="/userActivityWorkflow">User Activity</Link>
      </div>
      <div className="flex-height link-item">
        <Link to="/secureForms">Secure Forms</Link>
      </div>
      <div className="flex-height link-item">
        <Link to="/authorizedDeviceEnrollmentWorkflow">Device Enrollment</Link>
      </div>
      <div className="flex-height link-item">
        <DisabledPrompt>
          <Link to="">Delete an Account</Link>
        </DisabledPrompt>
      </div>
      <div className="flex-height link-item">
        <Link to="/acceptedDisclosuresWorkflow">Accepted Disclosures</Link>
      </div>
    </div>
  );
}